import React from "react";
import { MealTypeItem } from "../types";

interface FoodItemsListProps {
  items: MealTypeItem[];
}

export default function FoodItemsList({ items }: FoodItemsListProps) {
  return (
    <div className="space-y-2 sm:space-y-3">
      {items.map((item, index) => (
        <div
          key={`${item.name}-${index}`}
          className="rounded-lg sm:rounded-xl border border-stroke bg-white p-3 sm:p-5 shadow-sm dark:border-strokedark dark:bg-boxdark"
        >
          <div className="flex flex-col gap-3">
            {/* Header do item */}
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="flex h-7 w-7 sm:h-8 sm:w-8 flex-shrink-0 items-center justify-center rounded-full bg-purple-100 text-xs sm:text-sm font-bold text-purple-600 dark:bg-purple-900/30 dark:text-purple-400">
                    {index + 1}
                  </div>
                  <div className="min-w-0">
                    <h4 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white truncate">
                      {item.name}
                    </h4>
                    {item.nome_taco && (
                      <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                        TACO: {item.nome_taco}
                      </p>
                    )}
                  </div>
                </div>

                {/* Quantidades */}
                <div className="mt-2 sm:mt-3 ml-9 sm:ml-11">
                  <p className="mb-1.5 sm:mb-2 text-xs font-medium text-gray-600 dark:text-gray-400">
                    Quantidades registradas:
                  </p>
                  <div className="flex flex-wrap gap-1.5 sm:gap-2">
                    {item.quantities.map((qty, qtyIndex) => (
                      <span
                        key={qtyIndex}
                        className="rounded-md sm:rounded-lg bg-purple-50 px-2 sm:px-3 py-1 text-xs sm:text-sm font-medium text-purple-700 dark:bg-purple-900/20 dark:text-purple-300"
                      >
                        {qty}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="ml-9 sm:ml-0 flex flex-row items-end gap-2 sm:gap-2 flex-shrink-0">
                <div className="rounded-lg bg-gray-100 px-3 sm:px-4 py-1.5 sm:py-2 dark:bg-gray-800">
                  <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
                    Consumido
                  </p>
                  <p className="mt-0.5 sm:mt-1 text-base sm:text-lg font-bold text-gray-900 dark:text-white">
                    {item.occurrences}x
                  </p>
                </div>
                <div className="rounded-lg bg-purple-100 px-3 sm:px-4 py-1.5 sm:py-2 dark:bg-purple-900/30">
                  <p className="text-xs font-medium text-purple-700 dark:text-purple-400">
                    Calorias
                  </p>
                  <p className="mt-0.5 sm:mt-1 text-base sm:text-lg font-bold text-purple-600 dark:text-purple-400">
                    {item.total_calories.toLocaleString("pt-BR")}
                  </p>
                </div>
              </div>
            </div>

            {/* Macros do item */}
            {item.macros &&
              (item.macros.proteina_g > 0 || item.macros.carboidrato_g > 0) && (
                <div className="ml-9 sm:ml-11 mt-1">
                  <div className="flex flex-wrap gap-2 sm:gap-3">
                    <div className="flex items-center gap-1.5 rounded-md bg-blue-50 px-2 py-1 dark:bg-blue-900/20">
                      <span className="text-xs text-blue-600 dark:text-blue-400">
                        P:
                      </span>
                      <span className="text-xs font-semibold text-blue-700 dark:text-blue-300">
                        {item.macros.proteina_g.toLocaleString("pt-BR", {
                          maximumFractionDigits: 1,
                        })}
                        g
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 rounded-md bg-amber-50 px-2 py-1 dark:bg-amber-900/20">
                      <span className="text-xs text-amber-600 dark:text-amber-400">
                        C:
                      </span>
                      <span className="text-xs font-semibold text-amber-700 dark:text-amber-300">
                        {item.macros.carboidrato_g.toLocaleString("pt-BR", {
                          maximumFractionDigits: 1,
                        })}
                        g
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 rounded-md bg-red-50 px-2 py-1 dark:bg-red-900/20">
                      <span className="text-xs text-red-600 dark:text-red-400">
                        G:
                      </span>
                      <span className="text-xs font-semibold text-red-700 dark:text-red-300">
                        {item.macros.lipideos_g.toLocaleString("pt-BR", {
                          maximumFractionDigits: 1,
                        })}
                        g
                      </span>
                    </div>
                    {item.macros.fibra_alimentar_g > 0 && (
                      <div className="flex items-center gap-1.5 rounded-md bg-green-50 px-2 py-1 dark:bg-green-900/20">
                        <span className="text-xs text-green-600 dark:text-green-400">
                          F:
                        </span>
                        <span className="text-xs font-semibold text-green-700 dark:text-green-300">
                          {item.macros.fibra_alimentar_g.toLocaleString(
                            "pt-BR",
                            { maximumFractionDigits: 1 },
                          )}
                          g
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
      ))}
    </div>
  );
}
